module.exports = __webpack_public_path__ + "img/mrBts_test_004_BS.36c17d40.jpg";